/**
 * Слайдер с новостями
 */
import Swiper from 'swiper';

let newsSwiper = new Swiper('#newsSwiper', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  grabCursor: true,
  breakpoints: {
    768: {
      slidesOffsetBefore: 10,
      slidesOffsetAfter: 10,
    },
    1200: {
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  },
});